import styled from 'styled-components';

const Container = styled.div`
  flex: 1;

  > * {
    margin-bottom: 20px;
  }

  .selectSetsContainer {
    margin-top: 40px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    > *:not(:last-child) {
      margin-right: 20px;
    }
  }
`;

const PriceDiv = styled.div`
  position: relative;
  display: grid;
`;

const EvolutionLineChartDiv = styled.div`
  .exportButtonContainer {
    padding-bottom: 10px;
    margin-top: 10px;
  }

  .rightComponentsContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};

    > :not(:last-child) {
      margin-right: 15px;
    }
  }
  .selectSetsContainer {
    margin-top: 120px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
  }

  .labelCheckbox {
    margin-right: 20px;
    font-size: 14px;
    margin-left: 10px;
  }

  .orText {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
    font-size: 16px;
    margin-left: 10px;
    margin-right: 30px;
  }

  .setListContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    margin-top: 5px;

    > div {
      margin: 0 !important;
      height: 30px !important;
      white-space: nowrap !important;
      width: initial !important;
    }

    .tag {
      width: initial !important;
    }

    > div:not(:last-child) {
      margin-right: 10px !important;
    }
  }

  .tooltipContainer {
    display: flex;
    flex-direction: column;
  }

  .tooltipHeader {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 8px;
    width: 100%;
  }

  .tooltipHeaderLabelContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    width: 60%;
    margin-left: auto;
  }

  .tooltipDate {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 12px;
    text-transform: uppercase;
    color: #abb5be;
  }

  .tooltipHeaderLabel {
    height: 17px;
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 12px;
    color: #1f2b37;
  }

  .recharts-cartesian-axis-tick-value {
    font-size: 12px;
  }
`;

export default Container;
export { PriceDiv, EvolutionLineChartDiv };
